<template>
	<div class="calendar" id="datePicker">
		<button type="button" class="calendar.btn" id="minidatepick">点击选择日期</button>
	</div>
</template>

<script>
	import {minidatepicker} from '../libs/calendar.js'
	export default{
		data(){
			return{
				fixedDataArr:[],//不变的数据
				selectType:'add',//针对不同操作是否可选择日历
			    isOPeration:false,//针对是否已经选择了场地
				
			 }
		},
		mounted(){
	       this.initDate()
		},
		props:['fixedData','selectDateType','isSelectDate','isSingle'],
		watch: {
			fixedData: {
				handler(newVal) {
					if(newVal){
						this.fixedDataArr = newVal
						if($(".miniDatepickerWrapper")){
							$(".miniDatepickerWrapper").remove();
						}
						this.initDate()
					}
					
				},
				deep: true,
				immediate: true
			},
			selectDateType:{
				handler(newVal) {
					this.selectType = newVal
					if(newVal == 'add'){
						//console.log(newVal,'new')
						 this.fixedDataArr = []
					}
				
					if($(".miniDatepickerWrapper")){
						$(".miniDatepickerWrapper").remove();
					}
					this.initDate()
					
				},
				deep: true,
				immediate: true
			},
			isSelectDate:{
				handler(newVal) {

					this.isOPeration = newVal
					if($(".miniDatepickerWrapper")){
						$(".miniDatepickerWrapper").remove();
					}
					this.initDate()
					
				},
				deep: true,
				immediate: true
			}
		},

		methods:{
			formatDate(dateArr){
				let resultArr = [];
				dateArr.map(item => {
					if(item.am){
						resultArr.push({noon:'1',day:item.datestr})
					}
					if(item.pm){
						resultArr.push({noon:'2',day:item.datestr})
					}
				})
				this.$emit("userSelectData",resultArr)
			},
			initDate(){
				let that = this;
			    var start =  $.datePickerPrototype.day(0,$.datePickerPrototype.now());
				var startdate;
				if(this.fixedData.length > 0 ){
					if(this.fixedData[0].datestr > start){
						startdate = start
					}else{
						if(that.selectType == 'edit'){
							startdate = this.fixedData[0].datestr
						}else{
							startdate = start
						}
						
					}
				}else{
					startdate = start
				}
				
				//var startdate = $.datePickerPrototype.day(0,$.datePickerPrototype.now());
				
				$("#minidatepick").minidatepicker({
					//语言：cn中午，en英文
					lang: "cn",
					//开始日期：格式：2017-01-01，默认当前日期
					startDate: startdate,
					//可选范围，默认为7天
					dateCycle: 30,
					//最大选择日期个数，默认为7
					maxSelectCount: that.isSingle || 30,
					//最少选择日期个数,默认为1
					minSelectCount: 1,
					//是否必须连续选择，默认false
					continuity: false,
					//默认选中日期
					selectDayArr: [],
					//后台数据
					selectDataArr:that.fixedDataArr,
					//是否可选择
					selectType:that.selectType,
					//是否可操作
					isOPeration:that.isOPeration,
					// 点击清除日期前执行
					onBeforeClear: function(selectDates) {
						console.log(selectDates);
					},
					// 点击选中后日期执行
					onSelectDay: function(datas) {
						if(datas.length > 0){
							that.formatDate(datas)
						}else{
							that.$emit("userSelectData",[])
						}
					},
					// 点击确定按钮后执行
					onConfirm: function(dates) {
						// console.log(dates);
						// $("#selectDates").html(JSON.stringify(dates));
					},
				});
			}
		}
	}
</script>

<style lang="scss">
	@include component(calendar){
		position: relative;
		display: flex;
		height: 440px;;
		justify-content: flex-start;
		
		@include part(btn){
			width: 200px;
			height: 30px;
			background: linear-gradient(to left, #9853af, #623AA2);
			color: #fff;
			border: none;
			border-radius: 3px;
			font-size: 16px;
		
		}
		@include part(data){
			width: 100%;
			height: 100px;
			position: absolute;
			bottom: 0;
			left: 0;
			display: flex;
			justify-content: flex-start;
			padding-top: 10px;
			font-size: 16px;
			span{
				&:nth-child(1){
					font-weight: bold;
				}
			}
		}
	}
</style>
